import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MotifIconButton } from '../../button/icon-button/icon-button';
import { MotifTypeahead } from '../typeahead/typeahead';
import { ReactComponent as ActionIcSearch24px } from '../../../assets/icons/action/ic_search_24px.svg';

const defaultIcons = {
  search: <ActionIcSearch24px />
};

/**
 * @typedef Props
 * @prop {{search: React.ReactNode}} [icons]
 * @prop {string} [className]
 * @prop {string} [value]
 * @prop {{}} [searchButtonProps]
 * @prop {boolean} [disabled]
 * @prop {boolean} [hideClearButton]
 * @prop {string} [searchButtonTitle]
 * @prop {() => void} [onSearchButtonClick]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifSearch = (props) => {
  const {
    onSearchButtonClick = () => null,
    searchButtonTitle = 'Search',
    value = '',
    hideClearButton = false,
    disabled = false,
    className = '',
    searchButtonProps = {},
    icons: userIcons = {},
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };

  const classes = classNames({
    'motif-search-input-wrapper': true,
    'motif-search-disabled': disabled,
    [className]: true
  });

  const handleSearchButtonClick = () => {
    if (!disabled) {
      onSearchButtonClick();
    }
  };

  return (
    <div className={classes} data-motif-search>
      <MotifTypeahead
        value={value}
        hideClearButton={hideClearButton}
        disabled={disabled}
        type="search"
        {...other}
      />
      {(!value || value.length < 0 || hideClearButton) && (
        <MotifIconButton
          className="motif-search-input-icon motif-search-input-icon-button"
          type="button"
          disabled={disabled}
          title={searchButtonTitle}
          onClick={handleSearchButtonClick}
          {...searchButtonProps}
        >
          {icons.search}
        </MotifIconButton>
      )}
    </div>
  );
};

MotifSearch.propTypes = {
  onSearchButtonClick: PropTypes.func,
  searchButtonTitle: PropTypes.string,
  value: PropTypes.string,
  hideClearButton: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  searchButtonProps: PropTypes.instanceOf(Object),
  icons: PropTypes.shape({
    search: PropTypes.node
  })
};

export { MotifSearch };
